<!-- spinner bloqueador delante de todo -->
@if (procesandoVenta()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center" style="backdrop-filter: blur(4px)">
    <div class="bg-white rounded-xl p-6 flex flex-col items-center gap-4 shadow-lg">
      <app-progress-spinner strokeWidth="4" size="40" ariaLabel="Procesando venta" />
      <span class="text-slate-700 font-medium">Procesando venta...</span>
    </div>
  </div>
}

<!-- ═══════════ VERSIÓN DESKTOP (original) ═══════════ -->
<div class="hidden lg:grid lg:grid-cols-2 lg:gap-4">
  <div class="flex flex-col min-h-0">
    <div class="flex-1 overflow-y-auto pr-1">
      <div class="mb-4">
        <label class="block text-xs sm:text-sm font-medium text-slate-700 mb-2">IGV</label>
        <div class="flex flex-wrap gap-2 sm:gap-3">
          @for (opcion of opcionesIgv; track opcion.valor) {
            <label class="flex items-center gap-2 rounded-lg border px-3 py-2 text-sm cursor-pointer transition-colors"
              [class]="igvPorcentaje() === opcion.valor ? 'border-accent-500 bg-accent-50 text-accent-700' : 'border-slate-200 bg-white text-slate-700 hover:border-slate-300'">
              <input type="radio" name="igv_porcentaje" class="h-4 w-4 accent-accent-600" [checked]="igvPorcentaje() === opcion.valor" (change)="onChangeIgvPorcentaje(opcion.valor)" />
              <span>{{ opcion.label }}</span>
            </label>
          }
        </div>
      </div>
      <div class="mb-4">
        <label class="block text-xs sm:text-sm font-medium text-slate-700 mb-2">Tipo de Comprobante</label>
        <div class="flex flex-wrap gap-2">
          @for (documento of tipo_documentos; track $index) {
            <button class="min-w-0 px-3 sm:px-5 py-2 rounded-lg font-medium text-sm active:scale-[0.98] transition-colors"
              [class]="documento == formProcesarVenta().controlValue().tipo_documento ? 'bg-accent-600 text-white hover:bg-accent-500' : 'bg-slate-100 hover:bg-slate-200 text-slate-700'"
              (click)="selectTipoDocumento(documento)">{{ documento.split('_').join(' ') }}</button>
          }
        </div>
      </div>
      <div class="mb-4"><app-buscador-cliente [(cliente)]="formProcesarVenta().controlValue().cliente" /></div>
      <div class="mb-4">
        <label class="flex items-center gap-2 cursor-pointer">
          <input type="checkbox" class="h-4 w-4 accent-emerald-600 rounded" [checked]="sendWhatsApp()" (change)="sendWhatsApp.set(!sendWhatsApp())" />
          <span class="text-xs sm:text-sm font-medium text-slate-700">Enviar {{ formProcesarVenta().controlValue().tipo_documento.toLowerCase().split('_').join(' ') }} por WhatsApp</span>
        </label>
        @if (sendWhatsApp() && !disableWhatsApp()) { <p class="text-xs text-emerald-600 mt-1">Se enviará al número registrado: {{ formProcesarVenta().controlValue().cliente?.numero_celular }}</p> }
        @if (showWhatsAppPhoneInput()) { <div class="mt-2"><app-whatsapp-phone-input [(numeroCelular)]="whatsAppNumber" [(selectedCountryCode)]="whatsAppCountryCode" /></div> }
      </div>
      <div class="mb-4">
        <label class="block text-xs sm:text-sm font-medium text-slate-700 mb-2">Descuento</label>
        <div class="flex flex-wrap gap-2">
          <input type="number" class="w-24 rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400"
            [value]="descuento().valor" (input)="descuento.update((desc) => ({ valor: $any($event.target).valueAsNumber || 0, efectivo: desc.efectivo }))" />
          <button class="flex-1 min-w-20 px-3 py-2 rounded-lg font-medium text-sm transition-colors"
            [class]="this.descuento().efectivo ? 'bg-accent-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'" (click)="onClickDescuentoEfectivo(true)">S/.</button>
          <button class="flex-1 min-w-20 px-3 py-2 rounded-lg font-medium text-sm transition-colors"
            [class]="!this.descuento().efectivo ? 'bg-accent-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'" (click)="onClickDescuentoEfectivo(false)">%</button>
        </div>
      </div>
      <div class="mb-4"><app-agregar-pago (agregar)="agregarMetodoPago($event)" [monto_pago]="total()" [monto_pago_sugerido]="total()" /></div>
      <div class="mb-2">
        <label class="block text-xs sm:text-sm font-medium text-slate-700 mb-2">Observaciones</label>
        <textarea rows="3" class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 resize-none placeholder:text-slate-400"
          placeholder="Ingrese observaciones adicionales..." [formField]="$any(formProcesarVenta.observaciones)"></textarea>
      </div>
    </div>
    <div class="shrink-0 pt-3 border-t border-slate-100 mt-2">
      <div class="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-3">
        <app-button label="Venta a crédito" icon="bi bi-clock-fill" variant="warning" class="w-full! sm:w-auto!" (onClick)="ventaCredito()" [disabled]="procesandoVenta()"
          [appTooltip]="formProcesarVenta().controlValue().cliente != null ? null : 'Seleccione un cliente para venta a crédito'" tooltipPosition="bottom" />
        <app-button label="Finalizar venta" icon="bi bi-lock-fill" [disabled]="!pagoCompleto() || procesandoVenta()" class="w-full! sm:w-auto!" (onClick)="finalizarVenta()" />
        <app-button label="Cancelar" icon="bi bi-x-circle-fill" variant="secondary" class="w-full! sm:w-auto!" [disabled]="procesandoVenta()" (onClick)="cerrarModal()" />
      </div>
    </div>
  </div>
  <div class="lg:border-l lg:border-slate-200 lg:pl-4 flex flex-col min-h-0">
    <div class="min-h-0 flex flex-col" style="max-height: 35vh">
      <label class="block text-sm font-semibold text-slate-700 mb-2 shrink-0">Productos</label>
      <div class="flex-1 overflow-y-auto pr-1 space-y-2 min-h-8">
        @for (prod of productosCarrito; track $index) {
          <div class="bg-slate-50 rounded-lg p-2.5 flex flex-wrap items-center justify-between gap-2 border border-slate-100">
            <div class="min-w-0"><div class="font-medium text-slate-800 text-sm">{{ prod.nombre }}</div><div class="text-xs text-slate-500">{{ prod.cantidad }} x {{ prod.precio | currency: 'PEN' : 'S/.' }}</div></div>
            <div class="font-semibold text-slate-700 text-sm whitespace-nowrap">{{ prod.cantidad * prod.precio | currency: 'PEN' : 'S/.' }}</div>
          </div>
        } @empty { <div class="text-xs text-slate-400 py-2 text-center">Sin productos</div> }
      </div>
    </div>
    <div class="shrink-0 border-t border-slate-100 my-2"></div>
    <div class="min-h-0 flex flex-col" style="max-height: 25vh">
      <label class="block text-sm font-semibold text-slate-700 mb-2 shrink-0">Pagos realizados</label>
      <div class="flex-1 overflow-y-auto pr-1 space-y-2 min-h-8">
        @for (pago of pagosRealizados(); track $index) {
          <div class="bg-slate-50 rounded-lg p-2.5 flex flex-wrap items-center justify-between gap-2 border border-slate-100">
            <div class="min-w-0 font-medium text-slate-800 text-sm">{{ pago.tipo_pago.nombre }}</div>
            <div class="font-semibold text-slate-700 text-sm whitespace-nowrap">{{ pago.monto | currency: 'PEN' : 'S/.' }}</div>
            <app-button icon="bi bi-x" variant="ghost" size="xs" rounded ariaLabel="Eliminar pago" (onClick)="eliminarMetodoPago($index)" />
          </div>
        } @empty { <div class="text-xs text-slate-400 py-2 text-center">Sin pagos registrados</div> }
      </div>
    </div>
    <div class="shrink-0 space-y-2 pt-3 mt-2 border-t border-slate-100">
      <div class="rounded-lg p-3" [class.bg-emerald-50]="pagoCompleto()" [class.bg-red-50]="!pagoCompleto()">
        <div class="flex justify-between text-sm mb-1">
          <span class="font-medium" [class.text-emerald-700]="pagoCompleto()" [class.text-red-700]="!pagoCompleto()">Total Pagado:</span>
          <span class="font-medium" [class.text-emerald-700]="pagoCompleto()" [class.text-red-700]="!pagoCompleto()">{{ totalPagado() | currency: 'PEN' : 'S/.' }}</span>
        </div>
        @if (vuelto() > 0) {
          <div class="flex justify-between text-sm mb-1"><span class="text-slate-600">Vuelto:</span><span class="font-medium text-red-600">{{ vuelto() | currency: 'PEN' : 'S/.' }}</span></div>
        } @else if (!pagoCompleto()) {
          <div class="text-xs text-red-500 mt-1">Falta por pagar: {{ total() - totalPagado() | currency: 'PEN' : 'S/.' }}</div>
        }
      </div>
      <div class="bg-accent-50 rounded-lg p-3 border border-accent-100">
        @if (this.descuentoFinal() > 0) {
          <div class="flex justify-between text-sm mb-1 text-slate-600"><span>Subtotal:</span><span>{{ totalBruto() | currency: 'PEN' : 'S/.' }}</span></div>
          <div class="flex justify-between text-sm mb-1 text-slate-600"><span>Descuento:</span><span>- {{ descuentoFinal() | currency: 'PEN' : 'S/.' }}</span></div>
        }
        <div class="flex justify-between font-semibold text-base text-accent-800"><span>Total a Pagar:</span><span>{{ total() | currency: 'PEN' : 'S/.' }}</span></div>
      </div>
    </div>
  </div>
</div>

<!-- ═══════════ VERSIÓN MOBILE (solo visible < lg) ═══════════ -->
<div class="lg:hidden flex flex-col gap-4">
  <div>
    <label class="block text-sm font-medium text-slate-700 mb-1.5">IGV</label>
    <div class="flex gap-2">
      @for (opcion of opcionesIgv; track opcion.valor) {
        <label class="flex items-center gap-1.5 rounded-lg border px-3 py-2 text-sm cursor-pointer" [class.border-accent-500]="igvPorcentaje() === opcion.valor" [class.bg-accent-50]="igvPorcentaje() === opcion.valor" [class.text-accent-700]="igvPorcentaje() === opcion.valor" [class.border-slate-200]="igvPorcentaje() !== opcion.valor">
          <input type="radio" name="igv_porcentaje_m" class="h-4 w-4 accent-accent-600" [checked]="igvPorcentaje() === opcion.valor" (change)="onChangeIgvPorcentaje(opcion.valor)" />
          <span>{{ opcion.label }}</span>
        </label>
      }
    </div>
  </div>

  <div>
    <label class="block text-sm font-medium text-slate-700 mb-1.5">Tipo de Comprobante</label>
    <div class="flex gap-2">
      @for (documento of tipo_documentos; track $index) {
        <button class="px-3 py-2 rounded-lg font-medium text-sm" [class.bg-accent-600]="documento == formProcesarVenta().controlValue().tipo_documento" [class.text-white]="documento == formProcesarVenta().controlValue().tipo_documento" [class.bg-slate-100]="documento != formProcesarVenta().controlValue().tipo_documento" [class.text-slate-700]="documento != formProcesarVenta().controlValue().tipo_documento" (click)="selectTipoDocumento(documento)">{{ documento.split('_').join(' ') }}</button>
      }
    </div>
  </div>

  <app-buscador-cliente [(cliente)]="formProcesarVenta().controlValue().cliente" />

  <div>
    <label class="flex items-center gap-2 cursor-pointer">
      <input type="checkbox" class="h-4 w-4 accent-emerald-600 rounded" [checked]="sendWhatsApp()" (change)="sendWhatsApp.set(!sendWhatsApp())" />
      <span class="text-sm font-medium text-slate-700">Enviar por WhatsApp</span>
    </label>
    @if (sendWhatsApp() && !disableWhatsApp()) { <p class="text-xs text-emerald-600 mt-1">Número: {{ formProcesarVenta().controlValue().cliente?.numero_celular }}</p> }
    @if (showWhatsAppPhoneInput()) { <div class="mt-2"><app-whatsapp-phone-input [(numeroCelular)]="whatsAppNumber" [(selectedCountryCode)]="whatsAppCountryCode" /></div> }
  </div>

  <div>
    <label class="block text-sm font-medium text-slate-700 mb-1.5">Descuento</label>
    <div class="flex gap-2">
      <input type="number" class="w-20 rounded-lg border border-slate-200 px-3 py-2 text-sm" [value]="descuento().valor" (input)="descuento.update((desc) => ({ valor: $any($event.target).valueAsNumber || 0, efectivo: desc.efectivo }))" />
      <button class="flex-1 py-2 rounded-lg font-medium text-sm" [class.bg-accent-600]="this.descuento().efectivo" [class.text-white]="this.descuento().efectivo" [class.bg-slate-100]="!this.descuento().efectivo" [class.text-slate-700]="!this.descuento().efectivo" (click)="onClickDescuentoEfectivo(true)">S/.</button>
      <button class="flex-1 py-2 rounded-lg font-medium text-sm" [class.bg-accent-600]="!this.descuento().efectivo" [class.text-white]="!this.descuento().efectivo" [class.bg-slate-100]="this.descuento().efectivo" [class.text-slate-700]="this.descuento().efectivo" (click)="onClickDescuentoEfectivo(false)">%</button>
    </div>
  </div>

  <app-agregar-pago (agregar)="agregarMetodoPago($event)" [monto_pago]="total()" [monto_pago_sugerido]="total()" />

  <div>
    <label class="block text-sm font-medium text-slate-700 mb-1.5">Observaciones</label>
    <textarea rows="2" class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" placeholder="Observaciones..." [formField]="$any(formProcesarVenta.observaciones)"></textarea>
  </div>

  <div>
    <label class="block text-sm font-semibold text-slate-700 mb-1.5">Productos</label>
    @for (prod of productosCarrito; track $index) {
      <div class="bg-slate-50 rounded-lg p-2.5 flex justify-between items-center border border-slate-100 mb-1.5">
        <div>
          <div class="font-medium text-slate-800 text-sm">{{ prod.nombre }}</div>
          <div class="text-xs text-slate-500">{{ prod.cantidad }} x {{ prod.precio | currency: 'PEN' : 'S/.' }}</div>
        </div>
        <div class="font-semibold text-slate-700">{{ prod.cantidad * prod.precio | currency: 'PEN' : 'S/.' }}</div>
      </div>
    } @empty { <div class="text-xs text-slate-400 py-2">Sin productos</div> }
  </div>

  <div>
    <label class="block text-sm font-semibold text-slate-700 mb-1.5">Pagos realizados</label>
    @for (pago of pagosRealizados(); track $index) {
      <div class="bg-slate-50 rounded-lg p-2.5 flex justify-between items-center border border-slate-100 mb-1.5">
        <span class="font-medium text-slate-800 text-sm">{{ pago.tipo_pago.nombre }}</span>
        <span class="font-semibold text-slate-700 text-sm">{{ pago.monto | currency: 'PEN' : 'S/.' }}</span>
        <app-button icon="bi bi-x" variant="ghost" size="xs" rounded (onClick)="eliminarMetodoPago($index)" />
      </div>
    } @empty { <div class="text-xs text-slate-400 py-2">Sin pagos</div> }
  </div>

  <div class="rounded-lg p-3" [class.bg-emerald-50]="pagoCompleto()" [class.bg-red-50]="!pagoCompleto()">
    <div class="flex justify-between text-sm"><span class="font-medium">Total Pagado</span><span class="font-semibold">{{ totalPagado() | currency: 'PEN' : 'S/.' }}</span></div>
    @if (vuelto() > 0) { <div class="flex justify-between text-sm mt-1"><span>Vuelto</span><span class="font-medium text-red-600">{{ vuelto() | currency: 'PEN' : 'S/.' }}</span></div> }
    @if (!pagoCompleto()) { <div class="text-xs text-red-500 mt-1">Falta: {{ total() - totalPagado() | currency: 'PEN' : 'S/.' }}</div> }
  </div>

  <div class="bg-accent-50 rounded-lg p-3 border border-accent-100">
    <div class="flex justify-between text-sm"><span>Total a Pagar</span><span class="font-semibold text-accent-800">{{ total() | currency: 'PEN' : 'S/.' }}</span></div>
  </div>

  <div class="flex flex-col gap-2">
    <button type="button" class="w-full py-3 rounded-lg font-medium text-sm bg-amber-50 text-amber-700 border border-amber-100" (click)="ventaCredito()" [disabled]="procesandoVenta()">
      <i class="bi bi-clock-fill mr-2"></i>Venta a crédito
    </button>
    <button type="button" class="w-full py-3 rounded-lg font-medium text-sm bg-accent-600 text-white" (click)="finalizarVenta()" [disabled]="!pagoCompleto() || procesandoVenta()">
      <i class="bi bi-lock-fill mr-2"></i>Finalizar venta
    </button>
    <button type="button" class="w-full py-3 rounded-lg font-medium text-sm bg-white text-slate-600 border border-slate-200" (click)="cerrarModal()" [disabled]="procesandoVenta()">
      <i class="bi bi-x-circle-fill mr-2"></i>Cancelar
    </button>
  </div>
</div>
